export const USER_ID_ATTRIBUTE = 'uid';
export const MOBILE_ATTRIBUTE = 'mobile';
export const VIP_LEVEL_ATTRIBUTE = 'vip_level';
const LEGACY_VIP_LEVEL_ATTRIBUTE = 'vip';

export const DEFAULT_VIP_LEVEL_COLORS = {
  0: '#F3F4F6',
  1: '#DBEAFE',
  2: '#DCFCE7',
  3: '#FEF3C7',
  4: '#FCE7F3',
  5: '#EDE9FE',
  6: '#CCFBF1',
  7: '#FFEDD5',
  8: '#FEE2E2',
  9: '#E0F2FE',
  10: '#ECFCCB',
  11: '#FAE8FF',
  12: '#E0E7FF',
  13: '#D1FAE5',
  14: '#FEF9C3',
  15: '#FFE4E6',
  16: '#CFFAFE',
  17: '#F3E8FF',
  18: '#D9F99D',
  19: '#FED7AA',
  20: '#FECACA',
};

const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;

const getContactAttribute = (contact, key) => {
  return (
    contact?.additional_attributes?.[key] ?? contact?.custom_attributes?.[key]
  );
};

const normalizeAttributeValue = value => {
  if (value === undefined || value === null) return '';
  return String(value);
};

export const getContactUserId = contact => {
  return normalizeAttributeValue(
    getContactAttribute(contact, USER_ID_ATTRIBUTE) ||
      contact?.identifier ||
      contact?.name
  );
};

export const getContactMobile = contact => {
  return normalizeAttributeValue(
    getContactAttribute(contact, MOBILE_ATTRIBUTE) || contact?.phone_number
  );
};

export const getVipLevel = contact => {
  const values = [
    getContactAttribute(contact, VIP_LEVEL_ATTRIBUTE),
    getContactAttribute(contact, LEGACY_VIP_LEVEL_ATTRIBUTE),
  ];

  return (
    values
      .map(value =>
        value === null || value === undefined || String(value).trim() === ''
          ? Number.NaN
          : Number(value)
      )
      .find(level => Number.isInteger(level) && level >= 0 && level <= 20) ??
    null
  );
};

export const getVipLevelLabel = contact => {
  const level = getVipLevel(contact);
  return level !== null ? `VIP ${level}` : '';
};

export const normalizeVipLevelColors = colors => {
  return Object.keys(DEFAULT_VIP_LEVEL_COLORS).reduce((result, level) => {
    const color = colors?.[level] || colors?.[Number(level)];
    result[level] = HEX_COLOR_REGEX.test(color)
      ? color
      : DEFAULT_VIP_LEVEL_COLORS[level];
    return result;
  }, {});
};

export const getVipLevelColor = (contact, colors) => {
  const level = getVipLevel(contact);
  if (level === null) return '';
  return normalizeVipLevelColors(colors)[level];
};

export const getVipBadgeStyle = (contact, colors) => {
  const color = getVipLevelColor(contact, colors);
  if (!color) return {};
  return {
    backgroundColor: color,
    borderColor: color,
    color: '#111827',
  };
};
